import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import useFetch from "../../../hooks/useAxios";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import Textarea from "../../shared/Textarea";
import CityModal from "../Cat/ModalFilter.js/CityModal";

const CreateStep3 = ({ prevStep, nextStep }) => {
  const { updatePlaceDetail, createInfoData ,apiUpdateResideces,setIsEditPlaceCompleter} = useCreatePlace();
  const [showCity, setShowCity] = useState(false);
  const [choseCityId, setchoseCityId] = useState([]); //city //start //end //count
  const [Stateinfo, setStateinfo] = useState([]);
  const [StateResults, setStateResults] = useState([]);
  const [chosenCity, setChoseCity] = useState(createInfoData.stepThree.city || []);
  const [chosenState, setChoseState] = useState([]);
  const [cityname, setCityName] = useState(createInfoData.stepThree.city[0]?.title || "")
  const [CityError, setCityError] = useState("");
   



  useEffect(() => {
   if(chosenCity.length !== 0  && chosenState.length !== 0){
    setCityName(`${chosenCity}`)
   }
  }, [
    chosenCity,chosenState
  ])

  

  const apiCityInfo = useFetch({
    method: "get",
    url: "api/locations",
    noHeader: true,
    trigger: true,
    argFunc: res => {
      setStateinfo(res.data);
      setStateResults(res.data);
    }
  });
  console.log(chosenState);
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    defaultValues: {
      city: createInfoData.stepThree.city,
      village: createInfoData.stepThree.village,
      address: createInfoData.stepThree.address,
      postal_code: createInfoData.stepThree.postal_code
    }
  });
  const onSubmit = data => {
    if(cityname === "" ){
      setCityError("انتخاب شهر اجباری است.")
    }else{
      updatePlaceDetail("stepThree", {
        city: chosenCity,
        village: data.village,
        address: data.address,
        postal_code: data.postal_code
      });
      nextStep();
    }
   
  };
  const {id}=useParams()
  const update = (data) => {
    if(cityname === "" ){
      setCityError("انتخاب شهر اجباری است.")
    }else{
      updatePlaceDetail("stepThree", {
        city: chosenCity,
        village: data.village,
        address: data.address,
        postal_code: data.postal_code
      });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps">
      <h2>آدرس اقامتگاه</h2>
      <p className="w-[100%]">
        آدرس و موقعیت بومگردی را مشخص کنید. آدرس دقیق، تنها پس از تایید پرداخت
        مهمان، به آن‌ها نمایش داده خواهد شد.
      </p>
      <form >
        <div className="createsteps--grid3 mt-[50px]">
          {/* <Input
            name="city"
            control={control}
            errors={errors}
            placeholder=" استان اصفهان ، نیریز"
            label="انتخاب استان و شهر"
            className="seconadary-input"
            register={{
              required: " عنوان اقامتگاه اجباری است"
            }}
          /> */}
          {/*  */}
          <div onClick={()=>setShowCity(true)}>
            <div className="City_Button-label">انتخاب استان و شهر</div>
            <div className="City_Butoon">
              
               {cityname.length > 0 ?  <p>{chosenCity[0].title}</p> : <p>شهر را وارد کنید</p> }
            </div>
            <span className="input__message text-red mt-[4px]">{CityError}</span>
          </div>
          <Input
            name="village"
            control={control}
            errors={errors}
            placeholder="ویلا ساحلی لوکس 2 خواب"
            label="روستا و یا محله"
            className="seconadary-input"
            register={{
              required: " روستا و یا محله اجباری است"
            }}
          />
          <Input
            name="postal_code"
            control={control}
            errors={errors}
            placeholder=" کد پستی"
            label="کد پستی ( اختیاری )"
            className="seconadary-input"
          />
        </div>
        <div className="createsteps--textarealabel mt-[50px]">
          <h6>آدرس اقامتگاه </h6>
          <p>
            آدرس اقامتگاه را با جزییات کامل وارد کنید تا مهمان بعد از رزرو
            بتواند اقامتگاه را به راحت پیدا کند. ( آدرس دقیق اقامتگاه، در سایت
            مایش داده نمی شودوتنها پس از قطعی شدن رزرو برای مهمان ارسال می شود.
            )
          </p>
        </div>
        <Textarea
          name="address"
          control={control}
          errors={errors}
          className="seconadary-input mt-[8px]"
          rows="5"
          register={{
            required: " آدرس اقامتگاه اجباری است "
          }}
        />
        <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
        {id &&<Button varient="primary" onClick={handleSubmit((d) =>update(d))}> 
                بروزرسانی اقامتگاه
              </Button>}
          <Button
            varient="gray"
            onClick={() => {
              prevStep();
            }}
          >
            مرحله قبلی
          </Button>

          <Button varient="primary" onClick={handleSubmit((d) =>onSubmit(d))}  type="submit">
            مرحله بعدی
          </Button>
        </div>
      </form>
      {showCity &&
        <CityModal
          setchoseCityId={setchoseCityId}
          choseCityId={choseCityId}
          setChoseCity={setChoseCity}
          chosenCity={chosenCity}
          closeModal={() => setShowCity(false)}
          Stateinfo={Stateinfo}
          setStateinfo={setStateinfo}
          StateResults={StateResults}
          setStateResults={setStateResults}
          notshowCount={true}
          choseoneCity={true}
          setChosenState={setChoseState}
        />}
    </div>
  );
};

export default CreateStep3;
